import { ThemeProvider } from '@emotion/react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { createTheme, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import NormalButton from 'components/atoms/Button/NormalButton';
import React, { SetStateAction, useState } from 'react';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectAuth } from 'features/auth/authSlice';
import SubscriptionPriceModal from 'components/molecules/SubscriptionPriceModal';
import CampaignModal from 'components/molecules/CampaignModal';
import CoinsModal from 'components/molecules/CoinsModal';
import { handleConnectWallet } from 'APIs/utils';
// import { browserName } from 'react-device-detect';
import BasicModal from 'components/molecules/Modal';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const ParaText = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: '#ffffff',
}));

const TitleText = styled(Typography)(({ theme }) => ({
  fontSize: '2.4rem',
  fontWeight: 'bold',
  color: '#ffffff',
}));

interface IBackstageSideBarProps {
  setCurrentTab: SetStateAction<any>;
  currentTab: string; 
}

const BackstageSidebar = ({
  setCurrentTab,
  currentTab,
}: IBackstageSideBarProps) => {
  const authState = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const handleWalletConnect = async () => {
    if (authState.id && window.ethereum && window.ethereum.isMetaMask) {
      setOpenModal(false);
      await handleConnectWallet(dispatch, authState.id);
    } else {
      setOpenModal(true);
    }
  };
  //if (browserName.includes('Mobile'))
  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Box
          sx={{
            maxWidth: '400px',
            marginTop: { xs: '80px', md: '180px' },
          }}
        >
          <TitleText style={{ margin: '1rem 0', fontSize: '1.6rem' }}>
            Welcome to Buku Backstage!
          </TitleText>
          <ParaText style={{ color: '#c1c1c1' }}>
            Backstage is our answer to helping creators monetize their audience.
            By providing unique and exclusive content to your fans, you'll be
            able to give more to your fans, while earning from it.
          </ParaText>
          <BasicModal
            sx={{ maxWidth: '260px' }}
            open={openModal}
            handleClose={() => setOpenModal(false)}
          >
            <ParaText style={{ color: '#c1c1c1' }}>
              Visit Buku.gg on MetaMask app to link on mobile. Otherwise, you
              can confirm on desktop!
            </ParaText>
          </BasicModal>
          <Grid
            container
            style={{
              justifyContent: 'space-between',
              margin: '1.8rem 0px',
              gap: '1rem',
            }}
          >
            {authState.isCreator && (
              <>
                {' '}
                <Grid item xs={12}>
                  <SubscriptionPriceModal>
                    <NormalButton
                      color="yellow"
                      text={'Set a subscription price'}
                      style={{ width: '100%' }}
                    />
                  </SubscriptionPriceModal>
                </Grid>
                <Grid item xs={12}>
                  <CampaignModal>
                    <NormalButton
                      text={'Setup a free trial/campaign'}
                      style={{ width: '100%' }}
                    />
                  </CampaignModal>
                </Grid>
                <Grid item xs={12}>
                  <CoinsModal>
                    <NormalButton
                      text={'Select supported coins'}
                      style={{ width: '100%' }}
                    />
                  </CoinsModal>
                </Grid>
                <Grid item xs={12}>
                  <NormalButton
                    text={'Message Blast'}
                    Icon={<RocketLaunchIcon />}
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row-reverse',
                      gap: '5px',
                    }}
                  />
                </Grid>
                {authState.id && (
                  <Grid item xs={12}>
                    <NormalButton
                      text={'Link MetaMask'}
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row-reverse',
                        gap: '5px',
                      }}
                      isDisabled={authState.walletAddress ? true : false}
                      onClick={() => handleWalletConnect()}
                    />
                  </Grid>
                )}
              </>
            )}
            {!authState.isCreator && (
              <Grid item xs={12}>
                <Link style={{ textDecoration: 'none' }} to="/backstage/kyc">
                  <NormalButton
                    color="yellow"
                    text="Apply for backstage posting"
                    style={{ width: '100%' }}
                  />
                </Link>
              </Grid>
            )}
          </Grid>

          {authState.isCreator && (
            <Grid sx={{ marginTop: '100px' }} item xs={12}>
              <NormalButton
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row-reverse',
                  gap: '5px',
                }}
                text={'Delete Backstage'}
                Icon={<ReportProblemIcon />}
              />
            </Grid>
          )}
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default BackstageSidebar;
